import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import Badge from '@material-ui/core/Badge';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';


const useStyles = makeStyles((theme) => ({
    paper: {
        marginLeft: 2,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        padding: theme.spacing(0.5),
    },
    badge: {
        paddingTop: 10,
        marginRight: 24,
    },
    selectFormControl: {
        margin: theme.spacing(1),
        minWidth: 90,
    },
    selectLabel: {
        fontSize: '0.8rem',
        transform: 'translate(0, 1.5px) scale(0.75)',
    },
    selectInput: {
        fontSize: '0.8rem',
        paddingTop: theme.spacing(0.5),
        paddingBottom: theme.spacing(0.5),
    },
}));


/**
 * AnnotationTableToolbar
 * @param {Object} props
 */
const AnnotationTableToolbar = props => {

    const handleSelection = selection => {
        if (props.onSelection)
            props.onSelection(selection);
    };

    const classes = useStyles();
    const { data, filter } = props;

    const currentMode = filter?.mode || 'all'; // Default to 'all' if undefined

    return (
        <div>
            <Grid container alignItems="center">
                <Hidden only={['xs', 'sm']}>
                    <Grid item >
                        <Badge badgeContent={data?.length || 0} color="secondary" className={classes.badge} overlap="rectangular">
                            <Typography noWrap variant="overline" display="block">Annotations</Typography>
                        </Badge>
                    </Grid>
                </Hidden>
                <Hidden only={['xs']}>
                    <Grid item >
                        <Paper elevation={0} className={classes.paper}>
                            <FormControl variant="standard" className={classes.selectFormControl}>
                                <InputLabel id="filter-mode-select-label" className={classes.selectLabel}>Mode</InputLabel>
                                <Select
                                    labelId="filter-mode-select-label"
                                    id="filter-mode-select"
                                    value={currentMode}
                                    onChange={(event) => handleSelection({ mode: event.target.value })}
                                    label="Mode"
                                    className={classes.selectInput}
                                    margin="dense"
                                >
                                    <MenuItem value={'all'} style={{ fontSize: '0.8rem' }}>All</MenuItem>
                                    <MenuItem value={'area'} style={{ fontSize: '0.8rem' }}>Area</MenuItem>
                                </Select>
                            </FormControl>
                        </Paper>
                    </Grid>
                </Hidden>
            </Grid>
        </div>
    );
}

AnnotationTableToolbar.propTypes = {
    data: PropTypes.array,
    filter: PropTypes.object,
    onSelection: PropTypes.func,
};

export default AnnotationTableToolbar;
